import React from 'react';
import { Button, Radio, RadioChangeEvent, Modal } from 'antd';
import CloseIcon from '../../../../../../assets/finance/close_icon.png';
import './index.less';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import useIsMobile from '../../../../../../utils';

interface IQuizOption {
  indicator?: string;
  title: string;
  hint: string;
  isCorrect: boolean;
}

interface IQuizProps {
  title: string;
  description: string;
  question: string;
  options: IQuizOption[];
  onCompleted?: () => void;
}
const INDICATORS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const Quiz: React.FunctionComponent<IQuizProps> = (props) => {
  const {
    title = 'Scenario Question',
    description,
    question,
    options,
    onCompleted,
  } = props;

  const { courses, language } = useStore();
  const param = useParams();
  const p_course = param.course;
  const course = courses[p_course || ''];
  const { components: settings } = course;
  const isMobile = useIsMobile();
  options?.forEach((item, index) => {
    item.indicator = INDICATORS[index];
  });
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [state, setState] = React.useState<{
    submitted: boolean;
    selected: IQuizOption | undefined;
    selectedValue: string;
  }>({
    submitted: false,
    selected: undefined,
    selectedValue: '',
  });

  React.useEffect(() => {
    if (onCompleted && state.submitted && state.selected?.isCorrect) {
      onCompleted();
    }
  }, [state.selected?.isCorrect, state.submitted]);

  React.useEffect(() => {
    setState({
      ...state,
      selected: options?.find(
        (option) => option.indicator === state.selectedValue
      ),
    });
  }, [language]);

  if (!p_course) {
    return <div>Loading</div>;
  }
  // const getAnswerStyle = (itm: string) =>
  //   !state.submitted || itm !== state.selected?.indicator
  //     ? ''
  //     : state.selected.isCorrect
  //     ? RESULTS.CORRECT
  //     : RESULTS.WRONG;
  const onSelected = (e: RadioChangeEvent) => {
    if (state.submitted) {
      return;
    }
    setState({
      ...state,
      selectedValue: e.target.value,
      selected: options.find((option) => option.indicator === e.target.value),
    });
  };
  const submit = () => {
    if (!state.selected) {
      return;
    }
    setIsModalOpen(true);
    setState({
      ...state,
      submitted: true,
    });
  };
  const reset = () => {
    setIsModalOpen(false);
    setState({
      ...state,
      submitted: false,
      selected: undefined,
      selectedValue: '',
    });
  };
  return (
    <div className="quiz-section new-quiz">
      <h1 className="quiz-title">{title}</h1>
      <div className="quiz-section-body">
        <div className="top">
          <p
            className="quiz-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <div
            className="quiz-question"
            dangerouslySetInnerHTML={{ __html: question }}
          />
        </div>
        <div
          className="quiz-question-for-mobile"
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div className="quiz-button-section">
          <div className="quiz-answers">
            <Radio.Group onChange={onSelected} value={state.selectedValue}>
              {options?.map((option: IQuizOption, index) => (
                <div key={index} className="quiz-answers-item">
                  <Radio value={option.indicator}>
                    <span className="indicator">{option.indicator}</span>
                    {option.title}
                  </Radio>
                </div>
              ))}
            </Radio.Group>
          </div>
          <Button
            onClick={submit}
            className="quiz-submit-button"
            disabled={!state.selected}
            type="link"
          >
            <span>{settings?.submitLabel}</span>
          </Button>
        </div>
      </div>
      <Modal
        wrapClassName="rw-modal"
        maskStyle={{
          position: 'absolute',
        }}
        width={isMobile ? '100%' : `57.2rem`}
        mask={false}
        footer={null}
        getContainer={false}
        open={isModalOpen}
        closable={state.selected?.isCorrect}
        closeIcon={
          state.selected?.isCorrect ? (
            <img
              className="close-icon"
              src={CloseIcon}
              alt=""
              onClick={() => setIsModalOpen(false)}
            />
          ) : null
        }
      >
        <div>
          <div
            className={`quiz-result-area ${
              state.selected?.isCorrect ? 'correct' : 'wrong'
            }`}
          >
            <div className="text">
              <p>
                {state.selected?.isCorrect
                  ? settings?.correctLabel
                  : settings?.wrongLabel}
              </p>
              <div
                className="note"
                dangerouslySetInnerHTML={{
                  __html: state.selected?.hint || '',
                }}
              />
              {state.selected?.isCorrect || (
                <Button
                  onClick={reset}
                  className="quiz-try-again-button"
                  type="link"
                >
                  <span>{settings?.tryLabel}</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

Quiz.defaultProps = {
  onCompleted: undefined,
};

export default Quiz;
